import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHelp = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "currentColor",
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M18.1925 12.4953C17.9356 11.3804 16.8828 10.6358 15.746 10.765C14.6091 10.8942 13.7502 11.856 13.75 13.0001C13.7499 13.4144 13.4141 13.7501 12.9999 13.75C12.5856 13.7499 12.2499 13.4141 12.25 12.9999C12.2504 11.0929 13.6818 9.48987 15.5766 9.27455C17.4714 9.05924 19.226 10.3002 19.6542 12.1585C20.0825 14.0167 19.0479 15.9005 17.25 16.5361C16.9502 16.6421 16.7498 16.9256 16.75 17.2436V18.25C16.75 18.6642 16.4142 19 16 19C15.5858 19 15.25 18.6642 15.25 18.25V17.2444C15.2497 16.2906 15.8507 15.4398 16.75 15.1219C17.8287 14.7405 18.4495 13.6103 18.1925 12.4953Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.875 21.625C14.875 21.0037 15.3787 20.5 16 20.5C16.6213 20.5 17.125 21.0037 17.125 21.625C17.125 22.2463 16.6213 22.75 16 22.75C15.3787 22.75 14.875 22.2463 14.875 21.625Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4 16C4 9.37258 9.37258 4 16 4C22.6274 4 28 9.37258 28 16C28 22.6274 22.6274 28 16 28C9.37258 28 4 22.6274 4 16ZM16 5.5C10.201 5.5 5.5 10.201 5.5 16C5.5 21.799 10.201 26.5 16 26.5C21.799 26.5 26.5 21.799 26.5 16C26.5 10.201 21.799 5.5 16 5.5Z"
		})
	]
});
export { SvgHelp as ReactComponent };
